module.exports = __webpack_public_path__ + "static/media/paint-brush.b9818eb7.svg";